class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    updateDiscountBarAndRecommendations();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }
  
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
  
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function updateDiscountBarAndRecommendations() {
// 🔁 Fetch cart once
fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    // --- Update Discount Bar ---
    const bar = document.getElementById('discount-bar');
    const message = document.getElementById('discount-message');
    const progress = document.getElementById('discount-progress');

    if (bar && message && progress) {
      const total = cart.total_price / 100;

      let text = '';
      let percent = 0;

      if (total < 5000) {
        const diff = 5000 - total;
        text = `Spend ₹${diff.toFixed(0)} more to get 10% off.`;
        percent = (total / 5000) * 100;
      } else if (total >= 5000 && total < 8000) {
        const diff = 8000 - total;
        text = `🎉 Congratulations You’ve unlocked 10% off! Spend ₹${diff.toFixed(0)} more to get ₹1000 off.`;
        percent = ((total - 5000) / (8000 - 5000)) * 100;
      } else if (total >= 8000) {
        text = `🎁 Congratulations You’ve unlocked ₹1000 off!`;
        percent = 100;
      }

      bar.style.display = text ? 'block' : 'none';
      message.textContent = text;
      const clampedPercent = Math.min(percent, 100);
  progress.style.width = `${clampedPercent}%`;
  progress.style.backgroundColor = clampedPercent === 100 ? '#ea3c57' : '#28a745';
    }

    // --- Load Recommendations ---
    if (cart.items.length > 0) {
      const productId = cart.items[0].product_id;
      fetch(`/recommendations/products.json?product_id=${productId}&limit=4`)
        .then(res => res.json())
        .then(data => {
          const container = document.getElementById('cart-recommendation-products');
          if (container) {
            container.innerHTML = '';
            const formatPrice = (amount) => {
                return `Rs. ${Number(amount / 100).toLocaleString('en-IN', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}`;
              };

              if (data.products.length > 0) {
                data.products.forEach(product => {
                  const price = formatPrice(product.price);
                  const compareAtPrice = product.compare_at_price 
                    ? `<del class="cart-recommendation-compare-price">${formatPrice(product.compare_at_price)}</del>` 
                    : '';
    
                  const productHtml = `
                    <div class="cart-recommended-product">
                      <a href="${product.url}" class="cart-recommended-product-url">
                        <img src="${product.featured_image}" alt="${product.title}" class="cart-recommended-product-img" height="100px" width="100px"/>
                        <p class="cart-recommended-product-title">${product.title}</p>
                      </a>
                      <p class="cart-recommended-product-price-conatiner">
                        <span class="cart-recommended-product-price">${price}</span>
                        ${compareAtPrice}
                      </p>
                    </div>`;
                  container.innerHTML += productHtml;
                });
              } else {
                container.innerHTML = '<p>No recommendations found.</p>';
              }
          }
        });
    }
  });
}
